import React from 'react';

import { useFormContext } from 'react-hook-form';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';
import classes from 'components/Dashboards/Reporting/ReportSettingsModal/components/ReportSettingsForm/components/ReportAccessSettings/components/SpecificUsersAccess/components/UsersAccessTable/NotifyOnUploadCell/NotifyOnUploadCell.module.scss';
import { Switch } from 'components/DesignSystem/Switch';

interface Props {
    notifyOnUpload: boolean;
    canHaveAccess: boolean;
    hasAccess: boolean;
    username: string;
}

export const NotifyOnUploadCell = ({ canHaveAccess, hasAccess, username, notifyOnUpload }: Props) => {
    const { setValue, getValues } = useFormContext<FormValues>();

    if (!canHaveAccess) return null;

    const isDisabled = !hasAccess;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const notifyNewState = event.target.checked;

        const usersAccessList = getValues('userAccessList');
        const updateUsersAccessList = usersAccessList.map((user) => {
            if (user.userName === username) {
                return {
                    ...user,
                    notifyOnUpload: notifyNewState,
                };
            } else {
                return user;
            }
        });

        setValue('userAccessList', updateUsersAccessList, { shouldDirty: true });
    };

    return (
        <div className={classes.centerInnerField}>
            <Switch disabled={isDisabled} onChange={handleChange} checked={notifyOnUpload} />
        </div>
    );
};
